var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner-container"},[_vm._l(((_vm.displayedCoupons)),function(item,index){return [_c((_vm.renderType),{tag:"component",attrs:{"couponData":(item),"isSingle":(_vm.couponList.length==1)},on:{"clickExtra":_vm.clickExtra}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }